/**
 * Wrapper for the Zebra Browser Print SDK.
 */
import getBrowserPrint, {LocalDevicesInfo, ZebraSDKDevice} from 'zebra-browser-print';

import BenchlingConfig from 'BenchlingConfig';
import ErrorSubclass from 'util/ErrorSubclass';
import uniqueId from 'util/uniqueId';

export class ZebraBrowserPrintException extends ErrorSubclass {}

export class ZebraDevice {
  name: string;
  id: string;

  constructor(readonly sdkDevice: ZebraSDKDevice) {
    this.name = sdkDevice.name;
    this.id = uniqueId('zebraDevice');
  }

  send(contents: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.sdkDevice.send(
        contents,
        () => {
          resolve();
        },
        (errorMessage) => {
          reject(new ZebraBrowserPrintException(errorMessage));
        }
      );
    });
  }
}

export function getLocalZebraDevices(): Promise<Array<ZebraDevice>> {
  // By default, Zebra is configured to use port 9100. The config flag can be set to use a different port,
  // but requires that the customer have a bespoke version of zebra browser print. The https port is not
  // configurable (always uses 9101) because it's only actually used by some obscure browser setup.
  const port = BenchlingConfig.INVENTORY_ZEBRA_BROWSER_PRINT_HTTP_PORT_OVERRIDE ?? 9100;
  return new Promise((resolve, reject) => {
    getBrowserPrint(port).getLocalDevices(
      (devicesInfo: LocalDevicesInfo) => {
        if (devicesInfo.printer) {
          resolve(devicesInfo.printer.map((sdkDevice) => new ZebraDevice(sdkDevice)));
        } else {
          resolve([]);
        }
      },
      (errorMessage) => {
        reject(new ZebraBrowserPrintException(errorMessage));
      }
    );
  });
}
